import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <div>
      <Helmet>
        <title>Page Not Found — Vladyslav Chebotarov</title>
      </Helmet>
      <h1 className="text-xl font-bold mb-4">Page Not Found</h1>
      <hr className="mb-4" />
      <p className="text-sm text-muted mb-4">
        The page you're looking for doesn't exist.
      </p>
      <Link to="/" className="text-sm">&laquo; Back to home</Link>
    </div>
  );
}
